import {Link, Navigate, useNavigate} from "react-router-dom";
import React, {useContext,useEffect, useState} from "react";
import { HeaderLogo } from "../components/headerLogoComponent";
import { NavigationBar } from "../components/NavigationBar";
import '../../styles/mainpage.css';
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import HelperService from "../Services/Bll/HelperService";
import AppService from "../Services/Bll/AppService";
import { FilterPanel } from "../components/FilterPanelComponent";

import { PieChartCustom } from "../components/charts/PieChartCustom"
import { BarChartCustom } from "../components/charts/BarChartCustom"
import { BasicIndicator } from "../components/charts/BasicIndicator"
import {mockDataBar1, mockDataBar2, mockDataBar22, mockDataBar3} from "../data/mockPieDataBar";
import {motion as m} from "framer-motion"
import FilterPanelProvider from "../Provider/FilterPanelProvider";

import { ViewContext } from "../Context/ViewContext"

import KpiService from "../Services/Bll/KpiService";

import {createTheme, useMediaQuery} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import LoaderComponent from "../components/LoaderComponent";

export default function PaxPage() {
    const {loader, showLoader, hideLoader} = useContext(ViewContext);
    const kpiService = new KpiService();
    const [kpi, setKpi] = useState(null);
    const navigate = useNavigate()
    const logged = HelperService.isLogged()
    const [loadingPage, setLoadingPage] = useState(null);

    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
    });
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const fetchParams = {navigate, logged, showLoader, hideLoader, setKpi, isMobile};
        kpiService.fetchData(fetchParams)
    }, [])

    const handleKpiUpdate = (newsKpi) => {
        kpiService.handleKpiUpdate(newsKpi, setKpi)
    };


    const handleLoadingPage = (loading) => {
        setLoadingPage(loading);
    }

    const labels = {label: kpi?.label, labelSecond: kpi?.labelSecond};
    const viewsItem = localStorage.getItem('backclick')
    var directionAnimation = '';
    var nameclass = '';
    if (viewsItem == 1) {
        directionAnimation = '-100vw'
        nameclass = "reverseAnim"
    } else {
        directionAnimation = '100vw'
        nameclass = ""
    }

    if (loader) return null;

    return (
        <>
            <NavigationBar/>
            <FilterPanelProvider>
                {isMobile ? (
                    <Accordion className="h-auto" sx={{backgroundColor:'#b57ee3', borderRadius: '0 !important'}}>
                        <AccordionSummary
                            sx={{color:'white'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            <span style={{fontSize:'12px', fontWeight:'bold'}}>Filtre</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FilterPanel onKpiUpdate={handleKpiUpdate} isMobile={isMobile}
                                         onLoadingPage={handleLoadingPage}/>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <FilterPanel onKpiUpdate={handleKpiUpdate} onLoadingPage={handleLoadingPage}/>
                )}
            </FilterPanelProvider>
            <LoaderComponent loadingPage={loadingPage}/>
            {!loadingPage && (
                <div className={`indicContainer ${isMobile ? 'container' : ''}`}>
                    <BasicIndicator data={kpi?.currentPAX} dataBis={kpi?.currentPAXSecond} />
                    {kpi?.histo1 && <BarChartCustom data={kpi?.histo1} dataBis={kpi?.histo1Second}
                                                    title="Répartitions PAX par mois de départ" groupMode="grouped"
                                                    keysArray={['N', 'N-1']} width={"59%"} labels={labels} isNormal={true}/>}
                    {kpi?.histo2 && <BarChartCustom data={kpi?.histo2} dataBis={kpi?.histo2Second}
                                                    title="Répartitions PAX par destinations"
                                                    groupMode="grouped" keysArray={['N', 'N-1']} width={"80%"} fontSizeX={"8px"} labels={labels} isNormal={true}/>}
                </div>)}
        </>
    );
}









